module.exports = __webpack_public_path__ + "img/002.919231fa.png";